import {Injectable} from '@angular/core';
import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {PermissionArea} from '../../enums/permission-area.enum';
import {IconCode} from '../../enums/icon-code.enum';

@Injectable()
export class NavPasswordPolicyFactory extends NavFactory {
    protected static items = [
        {
            code: NavItemCodes.PASSWORD_POLICY_ADD,
            icon: IconCode.PASSWORD_POLICY_ADD,
            label: 'PASSWORD_POLICY.ADD',
            description: 'PASSWORD_POLICY.ADD',
            path: ['/admin/password-policies/add'],
        },
        {
            code: NavItemCodes.PASSWORD_POLICY_EDIT,
            icon: IconCode.PASSWORD_POLICY_EDIT,
            label: 'PASSWORD_POLICY.EDIT',
            description: 'PASSWORD_POLICY.EDIT',
            path: ({passwordPolicyId}) => ['/admin/password-policy', passwordPolicyId, 'edit']
        },
        {
            code: NavItemCodes.PASSWORD_POLICY_DELETE,
            icon: IconCode.PASSWORD_POLICY_DELETE,
            label: 'PASSWORD_POLICY.DELETE',
            description: 'PASSWORD_POLICY.DELETE'
        },
        {
            code: NavItemCodes.PASSWORD_POLICY_MANAGEMENT,
            icon: IconCode.PASSWORD_POLICY_MANAGEMENT,
            label: 'PASSWORD_POLICY.LIST.LABEL',
            description: 'PASSWORD_POLICY.LIST.DESC',
            path: '/admin/password-policies',
            permissionArea: PermissionArea.PASSWORD_POLICY_MANAGEMENT
        },
    ];
}
